import type { Messages } from '../messages.js'

/** Italian. `giri` for flips: what a tile does, and short enough for a meter. */
export const it: Messages = {
  tag: 'it',

  readingDictionary: 'Lettura del dizionario…',
  noWordList: 'Nessun elenco di parole per «{language}». Generalo:  pnpm dictionary build',
  emptyWordList: "L'elenco di parole per «{language}» è vuoto.",

  flips: 'giri',
  score: 'punti',
  words: 'parole',
  round: 'turno',
  ticksLeftLabel: 'Tempo restante nel turno',
  typeAWord: 'scrivi una parola',
  tapPrompt: 'tocca per prendere o restituire, poi {action}',

  boardOfTiles: 'Tabellone di {n} tessere',
  faceDown: 'coperta',
  wildCard: 'jolly',
  wildKey: 'una lettera qualsiasi',
  letterReplaced: '{from} è diventata {to}',
  letterSwap: 'CAMBIO DI LETTERA!',
  spentTile: 'tessera usata',
  hiddenWhilePaused: 'nascosta in pausa',
  letterInWord: '{letter}, lettera {position} della parola',

  completeWord: 'Completa parola',

  completeShort: 'Completa',
  reset: 'Cancella',
  pause: 'Pausa',
  resume: 'Riprendi',
  newGame: 'Nuova partita',
  paused: 'In pausa',
  outOfFlips: 'Giri esauriti',
  finalResult: '{score} punti con {words} in {rounds}',
  playAgain: 'Gioca ancora',
  share: 'Condividi',
  shareCopied: 'Copiato.',
  shareSelect: 'Copia questo:',

  lettersSelect: 'le lettere selezionano',
  keysWild: 'si prende quando scrivi una lettera che nessuna tessera mostra',
  clearsEvery: 'togle tutte le {letter} selezionate',
  undoLastLetter: 'annulla ultima lettera',
  noWordsYet: 'Nessuna parola per ora.',

  wordRejected: '{word}  {reason}',
  reasonDuplicate: 'già trovata',
  reasonTooShort: 'troppo corta',
  reasonNotAWord: 'non è una parola',
  reasonAllFound: 'li hai già tutti',
  noSuchLetterUp: 'nessuna {letter} scoperta',
  nothingUp: 'niente scoperto',
  letterHidden: 'una lettera si è nascosta',
  shuffled: 'mescolato',
  shuffledAndBilled: 'mescolato, addebitati {flips} giri non usati',
  tooFewLetters: 'Sono rimaste troppo poche lettere',

  gameLanguage: 'lingua',
  interfaceLanguage: 'interfaccia',
  dictionarySize: '{common} comuni su {full} parole',
  filterLanguages: 'Cerca lingue',
  noMatches: 'Nessun risultato',

  nerdMode: 'modo tecnico',
  rules: 'Regole',
  difficulty: 'difficoltà',
  difficultyNames: { easy: 'facile', medium: 'medio', hard: 'difficile', insane: 'infernale' },
  pausedNoBoard: 'Questa partita non entrerà in classifica.',
  about: 'Informazioni',
  themeLabel: 'tema',
  themeNames: { traditional: 'tradizionale', light: 'chiaro', contrast: 'alto contrasto' },
  tiles: 'tessere (N)',
  secondsPerTick: 'secondi / tempo',
  holdTicks: 'tempi di attesa',
  minWord: 'parola minima',
  startingFlips: 'giri iniziali',
  wildChance: 'probabilità di jolly',
  replaceChance: 'probabilità di cambio lettera',
  hideChance: 'probabilità di nascondere una lettera',
  wordCompleteMode: 'parola completata',
  wordCompleteNames: { shuffle: 'mescola', spend: 'consuma', keep: 'mantieni' },
  flipEconomy: 'economia dei giri',
  flipEconomyNames: {
    none: 'nessuna',
    perLetter: 'per lettera',
    fibonacci: 'fibonacci',
    overMinimum: 'oltre il minimo',
  },
  repeatedLetterKey: 'tasto lettera ripetuta',
  keySchemeNames: { cycle: 'ciclo', advance: 'avanza' },
  keySchemeHelp: {
    cycle:
      'A prende la prossima A libera e, quando sono tutte nella parola, le toglie. ' +
      'Maiusc+A le toglie anche.',
    advance: 'A prende la prossima A libera. Maiusc+A toglie tutte le A dalla parola.',
  },

  whatThatMeans: 'Cosa significa',
  factRound: 'un turno',
  factWholeBoardUp: 'tabellone intero visibile',
  factRoundCosts: 'un turno costa',
  factFlipsBuy: 'i giri iniziali valgono',
  factThisBoard: 'questo tabellone',
  factBoardHadToAdmit: 'il tabellone doveva ammettere',
  ticksAndSeconds: '{ticks}, {seconds}',
  wordsLongest: '{words}, la più lunga {longest}',
  wordsIncludingOneOf: '{words} inclusa una di {ceiling}',
  scorelessRounds: '{rounds} senza punti',

  whatAWordPays: 'Quanto rende una parola',
  columnLetters: 'lettere',
  columnCost: 'costo',
  columnPoints: 'punti',
  columnFlips: 'giri',
  columnNet: 'netto',

  canonicalRules: 'Regole {difficulty} ufficiali.',
  customRules:
    'Modificato dal preset. I punteggi con regole personalizzate non entrano in classifica.',
  applyAndStart: 'Applica e inizia una partita',
  changesNextGame: 'Le modifiche valgono dalla prossima partita.',
  presets: 'Preset:',

  start: 'Inizia',
  restart: 'Ricomincia',
  quit: 'Esci',
  quitTitle: 'Uscire da questa partita?',
  restartTitle: 'Ricominciare questa partita?',
  restartConfirm: 'Ricomincia',
  quitConfirm: 'Esci',
  keepPlaying: 'Continua',
  personalBest: 'Le tue migliori partite',
  newPersonalBest: 'Nuovo record personale.',
  columnRank: '#',
  notRanked: 'Regole personalizzate: questa partita non entra in classifica.',
  notRankedPaused: 'Il tempo si è fermato: questa partita non entra in classifica.',
  rankOfTotal: '{rank} di {total}',

  howToPlay: 'Come si gioca',

  backToGame: 'Torna al gioco',
  welcomeTitle: 'Benvenuto in Blinkered',
  tutorialSkip: 'Salta',
  tutorialNext: 'Avanti',
  tutorialBack: 'Indietro',
  tutorialStart: 'Inizia a giocare',
  tutorialHideAgain: 'Non mostrare più',
  tutorialProgress: '{n} di {total}',
  tutorialSkipTitle: 'Saltare la presentazione?',
  tutGoalTitle: 'Blinkered è una corsa',
  tutGoalBody:
    'Inizi la partita con un numero fisso di giri, e ogni tessera che si gira costa un giro. Quando i giri finiscono, la partita è chiusa. Le parole fanno guadagnare giri, e più la parola è lunga, più giri guadagni.',
  tutSpentBody:
    'Le lettere che usi in una parola restano a faccia in giù fino al turno successivo. Solo un cambio di lettera modifica quali lettere ci sono sul tabellone.',
  tutChangeTitle: 'Le lettere possono cambiare',
  tutSameLetters:
    'Hai visto una parola ma non hai fatto in tempo a giocarla? Le stesse lettere tornano al turno successivo, mescolate in posti nuovi.',
  tutPickLetters: 'Tocca le lettere che vuoi, in ordine, per comporre una parola.',
  tutMoreTurn:
    'Le tessere continuano a girarsi mentre pensi, quindi può ancora arrivare una lettera migliore.',
  tutTapBack:
    "Ne hai presa una per sbaglio? Toccala di nuovo per restituirla. Una qualsiasi, non solo l'ultima.",
  tutComplete: 'Premi Completa quando la parola è pronta.',
  htBoardTitle: 'Il tabellone',
  htBoardBody:
    'Le tessere si girano una alla volta, in ordine casuale. Le tessere scoperte servono a comporre parole.',
  htWordsTitle: 'Le parole',
  htWordsBody:
    'Componi una parola con le tessere scoperte, scrivendo o cliccando le lettere in ordine.',
  htFlipsTitle: 'I giri',
  htFlipsBody:
    'Ogni tessera che si gira costa un giro. Una parola completata aggiunge giri al tuo totale, e le parole lunghe ne rendono di più. Quando i giri finiscono, la partita è chiusa.',
  htRoundTitle: 'Il turno',
  htRoundBody:
    'Quando si gira l’ultima tessera del turno, il tabellone resta tutto scoperto per un momento. Poi le tessere vengono girate a faccia in giù e mescolate, e comincia un turno nuovo.',
  htLanguagesTitle: 'Le lingue',
  htLanguagesBody:
    '{n}. Ogni tabellone si può risolvere con parole di uso reale. Una parola insolita vale comunque, se il dizionario la conosce.',
  htKeysTitle: 'La tastiera',
  htWildTitle: 'I jolly',
  htWildBody:
    'A volte compare un jolly al posto di una lettera. Un jolly vale qualsiasi lettera che formi una parola valida. Una parola già completata non conta.',
  htHideTitle: 'Lettere che si nascondono',
  htHideBody:
    'Ai livelli più difficili una lettera scoperta può girarsi da sola e tornare più tardi nel turno. Il timer guadagna un segno in più per questo, in rosso. Le lettere già prese non si girano.',
  tutHideBody:
    'Ai livelli più difficili una lettera scoperta può girarsi da sola e tornare più tardi nel turno. Le lettere già prese non si girano.',
  htSwapTitle: 'Le lettere cambiano',
  htSwapBody:
    'A volte, tra un turno e l’altro, una lettera viene sostituita da un’altra. Vedrai quale lettera è stata tolta e quale è stata aggiunta.',
  htLevelsTitle: 'I livelli',
  htLevelEasy:
    'Le stesse dodici lettere per tutta la partita: puoi impararle e tenere a mente un elenco di parole. Le tessere si girano piano e il tabellone completo resta in vista abbastanza a lungo per finire di scegliere le lettere.',
  htLevelMedium:
    'Ogni tanto una lettera cambia, quindi diventa più difficile tenere a mente le parole che volevi giocare più avanti. Meno tempo per guardare e meno per pensare.',
  htLevelHard:
    'Le parole di tre lettere non contano più e una lettera cambia circa un turno sì e uno no. Il tabellone si vede appena prima di rimescolarsi.',
  htLevelInsane:
    'Tutto insieme, alla massima velocità. Il tabellone si rimescola quasi subito dopo l’ultimo giro.',
  htTouchTitle: 'Lo schermo a sfioramento',
  htTouchBody:
    'Tocca una tessera scoperta per prendere la sua lettera. Tocca una lettera già presa per restituirla. Completa e Cancella stanno sotto il tavoliere.',

  accountTitle: 'Il tuo account',
  menuProfile: 'Il mio profilo',
  menuGames: 'Le mie partite',
  menuPublicPage: 'La mia pagina pubblica',
  menuSignedInAs: 'Accesso eseguito come',
  signIn: 'Accedi',
  signOut: 'Esci',
  signInTitle: 'Accedi o registrati',
  signInLead: 'Un account conserva le tue partite, su ogni dispositivo.',
  signInKeepGame: 'Accedi per conservare questa partita, e tutte quelle dopo.',
  continueWithApple: 'Continua con Apple',
  continueWithGoogle: 'Continua con Google',
  signInOr: 'oppure',
  emailLabel: 'Email',
  codeLabel: 'Codice',
  emailMeACode: 'Inviami un codice',
  working: 'Un attimo…',
  sendNewCode: 'Invia un nuovo codice',
  codeSent: 'Controlla la posta. Il codice dura 10 minuti.',
  notNow: 'Non ora',
  badEmail: 'Non sembra un indirizzo email.',
  badCode:
    'Quel codice non ha funzionato. I codici scadono dopo 10 minuti e valgono una volta sola.',
  serverBusy: 'Server irraggiungibile. Riprova tra un momento.',
  serverDown: 'Server irraggiungibile.',
  offline: 'Offline',
  leaderboardTitle: 'Classifica',
  leaderboardEmpty: 'Ancora nessuna partita in questa classifica. Sii il primo.',
  leaderboardWouldBe: 'Dove si classificherebbe questa partita',
  leaderboardThisGame: 'Questa partita',
  leaderboardRanksHere: 'Dove si classifica questa partita',
  leaderboardOutside: 'Fuori dai primi cinque.',
  tutAccountTitle: 'Conserva i tuoi punteggi',
  tutAccountBody:
    'Un account salva le tue partite, mette i tuoi punteggi in classifica e conserva il tuo profilo.',
  ssoCancelled: 'Accesso annullato.',
  ssoExpired: 'Ci è voluto troppo. Riprova ad accedere.',
  ssoNoUsername:
    'Non è stato possibile completare la creazione dell’account. Riprova tra un momento.',
  ssoFailed: 'Non ha funzionato. Riprova, oppure usa la tua email.',
  tabProfile: 'Profilo',
  countryAny: 'Preferisco non dirlo',
  findCountry: 'Cerca paesi',
  usernameLabel: 'Nome utente',
  bioLabel: 'Bio',
  countryLabel: 'Paese',
  bioHint: 'Niente link. {left}/{max}',
  save: 'Salva',
  saving: 'Salvataggio…',
  saved: 'Salvato.',
  nameTaken: 'Quel nome ce l’ha già qualcuno.',
  nameTooShort: 'Un po’ più lungo, per favore.',
  nameTooLong: 'È troppo lungo.',
  nameBadCharacters: 'Solo lettere, cifre, trattini e trattini bassi.',
  nameBadEdges: 'Deve iniziare e finire con una lettera o una cifra.',
  nameMixedScripts: 'Scegli un solo alfabeto e restaci.',
  nameReserved: 'Sembra un nome che assegniamo noi. Scegline un altro.',
  nameUnusable: 'Quel nome non si può usare.',
  bioTooLong: 'Le bio hanno al massimo {max} caratteri.',
  bioHasLink: 'Nella bio i link non sono ammessi.',
  bioHasControl: 'Contiene caratteri che una bio non può contenere.',
  bioUnusable: 'Quella bio non si può usare.',
  gamesHeading: 'Partite',
  gamesEmpty: 'Qui non c’è ancora niente. Le partite giocate dopo l’accesso compariranno qui.',
  gamesEmptyShort: 'Qui non c’è ancora niente.',
  gamesLoading: 'Lettura delle tue partite…',
  theirGamesLoading: 'Lettura delle sue partite…',
  profileLoading: 'Lettura del profilo…',
  playerNotFound: 'Qui non c’è nessuno con quel nome.',
  columnWhen: 'Quando',
  columnRounds: 'turni',
  columnGame: 'Partita',
  gameLoading: 'Lettura della partita…',
  gameUnreadable: 'Non è stato possibile leggere questa partita.',
  gameNotRanked: 'Giocata con regole modificate, quindi non è in classifica.',
  detailNotKept: 'Le parole e i tabelloni di questa partita non sono più conservati.',
  openingBoard: 'Il tabellone iniziale',
  roundByRound: 'Turno per turno',
  roundNothing: 'niente trovato',
  changeReplaced: '{letter} sostituita nella casella {slot}',
  changeWildOn: '{letter} jolly nella casella {slot}',
  changeWildOff: '{letter} jolly tolto dalla casella {slot}',
  keepThisGame: 'Conserva questa partita',
  savedToYourGames: 'Salvata nelle tue partite.',

  reportThis: 'Segnala',
  reportHeading: 'Segnala questo',
  reportTheName: 'Il nome',
  reportTheBio: 'La descrizione',
  reportTheScore: 'Il punteggio',
  reportWhy: 'Cosa c’è di sbagliato? Facoltativo.',
  reportSend: 'Invia la segnalazione',
  reportSent: 'Grazie. Qualcuno ci darà un’occhiata.',
  reportSignIn: 'Accedi per segnalare qualcosa.',
  reportGone: 'Non c’è più.',
  reportCancel: 'Annulla',

  deleteAccount: 'Elimina il mio account',
  deleteAccountWhat:
    'Questo rimuove il tuo profilo e ogni partita che hai conservato, per sempre. Non si può annullare.',
  deleteAccountAsk: 'Mandami un codice',
  deleteConfirm: 'Elimina per sempre',
  deleteGone: 'Il tuo account non c’è più. Grazie per aver giocato.',
  deleteNoAddress:
    'Su questo account non c’è un indirizzo confermato, quindi un’eliminazione non può essere verificata. Scrivici e lo faremo a mano.',

  rulesetFacts: 'Parole di {letters} · una nuova tessera ogni {seconds}',
  plurals: {
    words: { one: '{n} parola', other: '{n} parole' },
    rounds: { one: '{n} turno', other: '{n} turni' },
    flips: { one: '{n} giro', other: '{n} giri' },
    ticks: { one: '{n} tempo', other: '{n} tempi' },
    points: { one: '{n} punto', other: '{n} punti' },
    minLetters: { one: '{n} lettera o più', other: '{n} lettere o più' },
    seconds: { one: '{n} secondo', other: '{n} secondi' },
  },
}
